export enum EndpointsConditionsQueryKeys {
  TokenizationConditions = '/tokenization/salom/conditions',
}

export enum ConditionsQueryKeys {
  TokenizationConditions = 'TokenizationConditions',
}
